import React, { Component } from 'react';
import './index.scss';

// import de Componentes do Bootstrap
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'


const PRICES = [
  'Até R$50,00',
  'De R$50,00 a R$100,00',
  'De R$100,00 a R$200,00',
  'Mais de R$200,00'
]

const BRANDS = [
  {id: 0, title: 'Amigurumi'},
  {id: 1, title: 'Macramê'},
  {id: 2, title: 'Euroroma'},
  {id: 3, title: 'Singer'},
  {id: 4, title: 'NYBC'},
  {id: 5, title: 'Jumbo'},
  {id: 6, title: 'Liza'},
  {id: 7, title: 'Fina'},
  {id: 8, title: 'Cisne'}
]


class FilterModal extends Component {

  state: any;

  constructor(props){
    super(props);
    this.state = {
      brandValues: [],
      priceValue: null
    }

    // this.setBtnVariant = this.setBtnVariant.bind(this);
  }

  private handleBrandFilter = button => {

    let tmp = this.state.brandValues;

    if (this.state.brandValues.includes(button)) {
      this.setState({
        brandValues: this.state.brandValues.filter(el => el !== button)
      })
    }

    else {
      tmp.push(button);

      this.setState({
        brandValues: tmp
      })
    }
  }

  private handlePriceFilter = ev => {

    if (this.state.priceValue === (ev)) {
      this.setState({
        priceValue: null
      })
    }

    else {
      this.setState({priceValue: ev});
    }
  }

  
  render () {
    return (
      <>
        <Modal.Header closeButton className="filter-header">
          <Modal.Title className="filter-title">
            Filtros
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="filter-type">
            <h2 className="my-5"> <span className="heading-border"> Ordenar por </span> </h2>
          </div>
          <div className="filter-type">
            <p className="filter-label"> Preço </p>
            <Col className="filter-price mb-3">
              {
                PRICES.map(key => 
                  <button
                    key={key}
                    onClick={() => this.handlePriceFilter(key)}
                    id="font-size-09"
                    className={key === this.state.priceValue ? "btn-pressed" : "btn-brand-action"}>
                    {key}
                  </button>
                )
              }
            </Col>
            <Row className="d-flex justify-content-center">
              <Col xs="5" sm="3" lg="2">
                <InputGroup size="sm" className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text className="input-group-price"> R$ </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl aria-label="Small" aria-describedby="inputGroup-sizing-sm" placeholder="Min"/>
                </InputGroup>
              </Col>
              <Col xs="5" sm="3" lg="2">
                <InputGroup size="sm" className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text className="input-group-price"> R$ </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl aria-label="Small" aria-describedby="inputGroup-sizing-sm" placeholder="Max"/>
                </InputGroup>
              </Col>
            </Row>
          </div>
          <div className="filter-type">
            <p className="filter-label"> Marcas </p>
            <Container className="filter-brand">
              <Row>
              <Col xs="auto">
                {
                  BRANDS.map(btn => (
                    <button 
                      key={btn.id} 
                      onClick={() => this.handleBrandFilter(btn.id)}
                      className={this.state.brandValues.includes(btn.id) ? "btn-pressed" : "btn-brand-action"}>
                      {btn.title}
                    </button>
                  ))
                }
              </Col>
              </Row>
            </Container>
            <hr/>
          </div>
          <span className="filter-action">
            <Button className="mb-3 btn-primary-action"> Aplicar filtros </Button> 
            <Button variant="link" className="btn-secondary-action" onClick={() => this.setState({brandValues: [], priceValue: null})}> Resetar filtros </Button> 
          </span>
        </Modal.Body>
      </>
    );
  }
}

export default FilterModal;
